import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { TypeMenssage } from '../../model/type-menssage.model';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor() { }

  public showToast(message: string, type: TypeMenssage) {
    let _type = this.getType(type);
    const position: any = "top right";
    const direction: any = "down-push";

    notify(
      {
        message: message,
        width: 400,
        type: _type,
        displayTime: 10000,
        closeOnClick: true,
        animation: {
          show: {
            type: 'fade', duration: 400, from: 0, to: 1,
          },
          hide: { type: 'fade', duration: 40, to: 0 },
        }
      }, { position, direction }
    );
  }

  public showToasts(messages: string[], type: TypeMenssage) {
    messages.forEach(msg => {
      this.showToast(msg, type);
    });
  }

  public showResponseViewModelToasts(response: any) {

    if (!response.Success)
      this.showToasts(response.Errors, TypeMenssage.danger);

    if (response.HasWarnings)
      this.showToasts(response.Warnings, TypeMenssage.warning);

    if (response.HasLogs)
      response.Logs.forEach((log: any) => console.log(log));
  }

  private getType(type: TypeMenssage): string {
    switch (type) {
      case TypeMenssage.info:
        return 'info';
      case TypeMenssage.warning:
        return 'warning';
      case TypeMenssage.danger:
        return 'error';
      case TypeMenssage.success:
        return 'success';
    }
  }
}
